import * as constants from '../constants'

const initialState = {
  client: {},
}

export function websocketReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_WEBSOCKET_CLIENT:
      return {
        ...state,
        client: action.client,
      }

    default:
      return state
  }
}
